/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceLayoutGroup
 */
export interface SurfaceLayoutGroup {
    /**
     * 
     * @type {string}
     * @memberof SurfaceLayoutGroup
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurfaceLayoutGroup
     */
    layouts: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SurfaceLayoutGroup
     */
    activeLayout: string;
}

export function SurfaceLayoutGroupFromJSON(json: any): SurfaceLayoutGroup {
    return SurfaceLayoutGroupFromJSONTyped(json, false);
}

export function SurfaceLayoutGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceLayoutGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'layouts': json['layouts'],
        'activeLayout': json['activeLayout'],
    };
}

export function SurfaceLayoutGroupToJSON(value?: SurfaceLayoutGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'layouts': value.layouts,
        'activeLayout': value.activeLayout,
    };
}


